import { LanguageCode } from "../common/enums";

const i18nSource: Record<string, Record<string, string>> = {
  [LanguageCode.en]: {
    "系统异常，请稍后重试": "System error, please try again later",
    "网络异常，稍后重试": "Network error, please try again later",
  },
  [LanguageCode.vi]: {
    "系统异常，请稍后重试": "Lỗi hệ thống, vui lòng thử lại sau",
    "网络异常，稍后重试": "Lỗi mạng, vui lòng thử lại sau",
  },
  [LanguageCode.in]: {
    "系统异常，请稍后重试": "Kendala pada sistem, coba kembali nanti",
    "网络异常，稍后重试": "Jaringan internet bermasalah, coba kembali nanti",
  },
  [LanguageCode.ms]: {
    "系统异常，请稍后重试": "System error, please try again later",
    "网络异常，稍后重试": "Network error, please try again later",
  },
  [LanguageCode.zh]: {
    "系统异常，请稍后重试": "系统异常，请稍后重试",
    "网络异常，稍后重试": "网络异常，稍后重试",
  },
  [LanguageCode.de]: {
    "系统异常，请稍后重试": "Systemfehler, versuchen Sie es später erneut",
    "网络异常，稍后重试": "Netzwerkfehler, versuchen Sie es später erneut",
  },
  [LanguageCode.es]: {
    "系统异常，请稍后重试": "Error de sistema. Prueba de nuevo más tarde",
    "网络异常，稍后重试": "Error de red. Vuelve a intentarlo más tarde.",
  },
  [LanguageCode.fr]: {
    "系统异常，请稍后重试": "Erreur du système, veuillez réessayer plus tard",
    "网络异常，稍后重试": "Problème de connexion, veuillez réessayer plus tard",
  },
  [LanguageCode.it]: {
    "系统异常，请稍后重试": "Errore di sistema, riprova più tardi",
    "网络异常，稍后重试": "Errore di rete, riprova più tardi",
  },
  [LanguageCode.pl]: {
    "系统异常，请稍后重试": "Błąd systemu. Proszę spróbować ponownie później.",
    "网络异常，稍后重试": "Błąd systemu. Spróbuj ponownie później.",
  },
};

export function translate(languageCode: LanguageCode, key: string): string {
  return i18nSource[languageCode]?.[key] || i18nSource.en[key];
}
